import { Component } from '@angular/core';
@Component({
  templateUrl: './agencysignup.component.html'
})
export class AgencySignupComponent {
}
